<template>
    <MiscLink
        :to="isLoggedIn ? '/customer' : '/customer/login'"
        tabindex="0"
        data-cy="customerLink"
        class="relative flex flex-col items-center"
        :aria-label="isLoggedIn ? $t('customer.state.account') : $t('customer.state.logIn')"
    >
        <div class="btn btn-circle btn-ghost">
            <MiscIcon v-if="isLoggedIn" name="user-check" class="user-check" />
            <MiscIcon v-else name="user" />
        </div>
        <span class="hidden text-xs lg:inline-block">
            <template v-if="isLoggedIn">
                {{ $t('customer.state.account') }}
            </template>
            <template v-else>
                {{ $t('customer.state.logIn') }}
            </template>
        </span>
    </MiscLink>
</template>

<script setup lang="ts">
const { isLoggedIn } = useUser()
</script>
